import React from 'react';
import { Section } from './ui/Section';
import { Sparkles } from 'lucide-react';
export function ProofSection() {
  return <Section bg="navy" className="text-white" data-id="element-164">
      <div className="max-w-3xl mx-auto text-center" data-id="element-165">
        <div className="flex justify-center mb-6" data-id="element-166">
          <Sparkles className="w-10 h-10 text-amber" data-id="element-167" />
        </div>
        <p className="text-2xl md:text-3xl font-serif italic leading-relaxed mb-8" data-id="element-168">
          "En solo 7 días después de aplicar este protocolo, la dinámica de tu
          hogar cambiará por completo."
        </p>
        <p className="text-lg text-white/80 leading-relaxed mb-8" data-id="element-169">
          Pasarás de limpiar manchas y esconder tus zapatos a disfrutar de un
          compañero que entiende los límites de tu casa.
        </p>
        <div className="inline-block border-t border-white/20 pt-6" data-id="element-170">
          <p className="text-xl font-bold text-amber uppercase tracking-widest" data-id="element-171">
            No es magia, es biología aplicada.
          </p>
        </div>
      </div>
    </Section>;
}